var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('a',{attrs:{"href":"http://www.cebpubservice.com/","target":"_blank"}},[_vm._v("返回首页")]),_c('span',{staticStyle:{"color":"#9e9e9e"}},[_vm._v("  |  ")]),_c('a',{attrs:{"href":"http://www.cebpubservice.com/low/us/index.shtml?20151216153242","target":"_blank"}},[_vm._v("联系我们")])])
}]

export { render, staticRenderFns }